<template>
  <div class="app-wrapper" :class="{ 'has-remind': showPwdRemind }">
    <!-- 左侧菜单栏 -->
    <div class="sidebar-container" :class="{ 'with-remind': showPwdRemind }">
      <Sidebar />
    </div>

    <!-- 右侧内容区域 -->
    <div class="main-container">
      <!-- 密码修改提醒 -->
      <transition name="slide-down">
        <div v-if="showPwdRemind" class="pwd-remind-bar">
          <span class="remind-icon">⚠</span>
          <span>你有长时间未修改密码，请点击</span>
          <a class="link" @click="goToUserInfo">个人信息</a>
          <span>修改密码。</span>
          <i class="el-icon-close close-icon" @click="closeRemind"></i>
        </div>
      </transition>
      <div class="navbar">
        <Navbar />
      </div>
      <div class="breadcrumb-container">
        <Breadcrumb />
      </div>
      <AppMain />
      <div class="icp-beian">
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >蜀ICP备2025148648号-2</a>
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from "./components";
import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: "Layout",
  components: {
    Navbar,
    Sidebar,
    AppMain,
    Breadcrumb,
  },
  data() {
    return {
      showPwdRemind: false,
    };
  },
  created() {
    this.checkPwdRemind();
  },
  methods: {
    checkPwdRemind() {
      this.showPwdRemind = localStorage.getItem("needResetPwd") === "true";
    },
    goToUserInfo() {
      this.$router.push("/system/user");
      this.closeRemind();
    },
    closeRemind() {
      this.showPwdRemind = false;
      localStorage.removeItem("needResetPwd");
    },
  },
};
</script>

<style lang="scss" scoped>
.pwd-remind-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  background: linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%);
  border-bottom: 2px solid #ffd54f;
  color: #5d4037;
  font-weight: bold;
  font-size: 14px;
  padding: 0 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);

  .remind-icon {
    margin-right: 8px;
    font-size: 16px;
    color: #ff9800;
  }

  .link {
    color: #1976d2;
    text-decoration: underline;
    cursor: pointer;
    margin: 0 4px;
    font-weight: bold;

    &:hover {
      color: #1565c0;
    }
  }

  .close-icon {
    margin-left: 15px;
    cursor: pointer;
    font-size: 16px;
    color: #757575;
    transition: color 0.2s;

    &:hover {
      color: #424242;
    }
  }
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}

.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}

.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;

  .sidebar-container {
    width: 210px;
    height: 100%;
    background: #304156;
    transition: all 0.3s;
    overflow-y: auto;

    &.with-remind {
      margin-top: 0;
    }
  }

  .main-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: auto;

    .navbar {
      height: 50px;
      background: #fff;
      box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    }

    .breadcrumb-container {
      height: 40px;
      background: #fff;
      border-bottom: 1px solid #e6e6e6;
      padding: 0 20px;
    }

    .app-main {
      flex: 1;
      padding: 20px;
      overflow-y: auto;
      background: #f0f2f5;
    }

    .icp-beian {
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      background: #f0f2f5;
      flex-shrink: 0;

      a {
        color: #909399;
        text-decoration: none;

        &:hover {
          color: #409eff;
        }
      }
    }
  }
}
</style>
